<div *ngIf="didSearch">
  <div *ngIf="sosCustomers!.length > 0; else noResults">
    <p>
      Stuur een
      <a [href]="getMailToLink()"
        >email
        {{ sosCustomers!.length === 1 ? 'aan deze klant' : 'aan al deze ' + sosCustomers!.length + ' klanten' }}</a
      >
      door op de link te klikken.
    </p>
    <button
      class="btn btn-outline-primary"
      (click)="downloadEmailAddresses()"
    >
      Download e-mailadressen
    </button>
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Klantgegevens</th>
          <th>Order(s)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sosCustomer of sosCustomers">
          <td>
            <div class="row">
              <div class="col-6">
                <div>
                  <a
                    href="{{ sosCustomer.customerId | omsCustomerLink }}"
                    target="_blank"
                    >{{ sosCustomer.shopCustomerNumber }}</a
                  >
                </div>
                <div>{{ sosCustomer.companyName }}</div>
              </div>
              <div class="col-6">
                <div>
                  <div>
                    <div>{{ sosCustomer.firstName }} {{ sosCustomer.lastName }}</div>
                  </div>
                  <div>
                    <a
                      href="mailto:{{ sosCustomer.emailAddress }}"
                      target="_blank"
                      >{{ sosCustomer.emailAddress }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td>
            <ul class="list-group list-group-flush">
              <li>
                <div class="row">
                  <div class="col-4 fw-semibold">Datum</div>
                  <div class="col-4 fw-semibold">leveranciers ordernummer</div>
                  <div class="col-4 fw-semibold">Indi ordernummer</div>
                </div>
              </li>
              <li *ngFor="let order of sosCustomer?.orders">
                <div class="row">
                  <div class="col-4">
                    {{ order.indiOrderDateTime | cleanDate: 'date-time' }}
                  </div>
                  <div class="col-4">{{ order.supplierOrderNumber }}</div>
                  <div class="col-4">
                    <a
                      href="{{ order.orderId | omsOrderLink }}"
                      target="_blank"
                      >{{ order.indiOrderNumber }}</a
                    >
                  </div>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #noResults>
    <div class="d-flex justify-content-center">
      <div class="p-5 border d-flex align-items-center">
        <i class="fa-solid fa-circle-xmark me-3 primary-color fa-2xl"></i>
        <span class="fs-4">Er zijn geen orders gevonden voor deze ordernummers. </span>
      </div>
    </div>
  </ng-template>
</div>
